import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Divider } from 'antd';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';

const StyledAlert = styled(Alert)`
  .ant-alert-description ul {
    padding-left: 0;
    margin-bottom: 0;
  }
`;

function ApplicantPendingApplicationsAlert({ selectedApplicant }) {
  if (!selectedApplicant?.pending_applications?.length) {
    return null;
  }

  const threeLatestPendingApplications = selectedApplicant.pending_applications?.slice(0, 3);
  const pendingCount = selectedApplicant.pending_applications?.length;
  const leftoverCount = pendingCount - 3;
  const leftoverLangKey =
    leftoverCount > 1
      ? 'landlordPortal.applicationManagement.inviteLeadToApply.applicationsInProgress.others'
      : 'landlordPortal.applicationManagement.inviteLeadToApply.applicationsInProgress.other';

  const applicantFullName =
    selectedApplicant.full_name || `${selectedApplicant.first_name} ${selectedApplicant.last_name}`;

  const description = (
    <ul>
      {threeLatestPendingApplications.map((application) => (
        <li key={application.id}>
          {getTranslatedString(
            'landlordPortal.applicationManagement.inviteLeadToApply.applicationsInProgress.item',
            {
              status: getTranslatedString(
                `landlordPortal.applicationManagement.inviteLeadToApply.application.statuses.${application.status}`
              ),
              unit: application.unit_number,
              property: application.property_name,
            }
          )}
        </li>
      ))}
      {leftoverCount > 0 && (
        <li key="the_rest">{`+${leftoverCount} ${getTranslatedString(leftoverLangKey)}`}</li>
      )}
    </ul>
  );
  return (
    <>
      <StyledAlert
        type="warning"
        message={`${applicantFullName} ${
          selectedApplicant.pending_applications.length === 1
            ? getTranslatedString(
                'landlordPortal.applicationManagement.inviteLeadToApply.applicationsInProgress.singular'
              )
            : getTranslatedString(
                'landlordPortal.applicationManagement.inviteLeadToApply.applicationsInProgress.plural'
              )
        }`}
        description={description}
        closable
        showIcon
      />

      <Divider />
    </>
  );
}

ApplicantPendingApplicationsAlert.propTypes = {
  selectedApplicant: PropTypes.object,
};

export default ApplicantPendingApplicationsAlert;
